const FocusVisiblePlugin = {
  // eslint-disable-next-line no-unused-vars
  install (Vue, options) {
    Vue.mixin({
      mounted () {
        if (window.applyFocusVisiblePolyfill != null) {
          window.applyFocusVisiblePolyfill(this.$el);
        }
      },
    });
  },
};

export default FocusVisiblePlugin;
